export class ForgotPasswordModel {
    userName: string;
    forgetPasswordId: string;
    
    constructor() {
        this.userName = '';
        this.forgetPasswordId = '';
    }
}
